<template>
  <div class="advanced-info__wrapper">
    <table class="child-table">
      <thead>
        <tr>
          <th
            v-for="(header, headerIdx) in Object.values(headers)"
            :style="{ 'background-color': header.color ? header.color : '#E3EEFF' }"
            :key="headerIdx"
          >
            <v-tooltip color="grey darken-3" top close-delay="50" v-if="header.name">
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on" v-bind="attrs" class="header-text"> {{ get(header, 'name_short', '') }}</span>
              </template>
              <span class="white--text">
                {{ get(header, 'name', '') }}
              </span>
            </v-tooltip>
            <span v-else class="header-text"> {{ get(header, 'name_short', '') }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            v-for="(header, headerIdx) in Object.keys(headers)"
            :key="headerIdx"
            :style="{ 'background-color': stat[header].isColumnDate ? 'white' : '#F8F7F7' }"
          >
            {{ stat[header].quantity || '--' }}
          </td>
        </tr>
        <tr v-for="(product, index) in items" :key="index">
          <td
            v-for="(inventory, idxInv) in product"
            :style="{ 'background-color': inventory.isColumnDate ? 'white' : '#F8F7F7' }"
            :key="idxInv"
          >
            {{ formatNumber(inventory.quantity) }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get, clone } from 'lodash'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
export default {
  computed: {
    ...mapState('importDeliveries', ['item', 'expectQuantity', 'inventory'])
  },
  data() {
    return {
      headers: [],
      items: [],
      totalQuantity: [],
      stat: {},
      get
    }
  },
  created() {},
  methods: {
    ...mapActions({
      setDeliveredAt: 'importDeliveries/setDeliveredAt'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    mapInventoriesHeaders(data) {
      let objHeaders = {}
      let listDays = {}
      data.forEach((i, indexDay) => {
        listDays[i.deliveredAt ? i.deliveredAt : 'null'] = {
          name_short: i.deliveredAt ? `SL về Ngày ${this.formatDateDDMMYYYY(i.deliveredAt || '')}` : 'SL về Ngày --/--',
          value: i.deliveredAt || '--',
          index: indexDay,
          isColumnDate: true
        }
        objHeaders[`${i.deliveredAt ? i.deliveredAt : 'null'}-${i.name_short}`] = {
          name_short: i.name_short,
          name: i.name,
          value: `${i.deliveredAt}-${i.name_short}`
        }
      })
      let sorted = {}
      Object.keys(listDays)
        .sort()
        .forEach((keyDay, index) => {
          sorted[keyDay] = { ...listDays[keyDay], index: (index + 1) * 100, color: '#c0d8ff' }
          Object.keys(objHeaders).forEach((keyData, index2) => {
            if (keyData.includes(keyDay)) {
              sorted[keyData] = { ...objHeaders[keyData], index: (index + 1) * 100 + index2, color: '#E3EEFF' }
            }
          })
        })
      const listDay = Object.keys({ ...listDays }).filter(x => x !== 'null')
      this.setDeliveredAt(listDay[0] ? listDay[0] : '')
      this.headers = sorted
    },
    handlerHeader(val) {
      const mapData = val.map(v => [...v.inventories].sort((a, b) => a.index - b.index))
      const inventories = [].concat(...mapData)
      const cloneMapData = clone(mapData)
      if (inventories) {
        const data = this.handlerTotalRowByDeliveriedAt(cloneMapData)
        cloneMapData.forEach((item, index) => (item = item.push(...data[index])))
        this.mapInventoriesHeaders(inventories)
        this.mapInventoriesContent(mapData)
      }
    },
    mapInventoriesContent(inventories) {
      const res = inventories.map(product => {
        const cloneHeaders = clone(this.headers, true)
        let newRowTable = cloneHeaders
        product.forEach(inventory => {
          if (inventory.name_short) {
            newRowTable[`${inventory.deliveredAt ? inventory.deliveredAt : 'null'}-${inventory.name_short}`] = {
              ...newRowTable[`${inventory.deliveredAt}-${inventory.name_short}`],
              quantity: inventory.quantity
            }
          } else {
            newRowTable[`${inventory.deliveredAt ? inventory.deliveredAt : 'null'}`] = {
              ...newRowTable[`${inventory.deliveredAt}`],
              quantity: inventory.quantity,
              color: 'white'
            }
          }
        })
        return Object.values(newRowTable)
      })
      this.items = res
    },
    mapExpectQuantity(inventories, quantity) {
      const cloneHeaders = clone(this.headers, true)
      const data = cloneHeaders
      for (const date in quantity) {
        for (const key in quantity[date]) {
          if (key === 'quantity') {
            data[date || 'null'] = { quantity: quantity[date][key], color: 'white', isColumnDate: true }
          } else {
            const inventoryKey = inventories[key] ? inventories[key].name_short : key
            data[`${date || 'null'}-${inventoryKey}`] = { quantity: quantity[date][key], color: '#F8F7F7' }
          }
        }
      }
      this.stat = data
    },
    handlerTotalRowByDeliveriedAt(arr) {
      return arr.map(innerArr => {
        const deliveredAt = [...new Set(innerArr.map(item => item.deliveredAt))]
        const result = deliveredAt.map(i => {
          if (i) {
            const totalQuantity = innerArr
              .filter(item => item.deliveredAt === i)
              .reduce((sum, item) => sum + item.quantity, 0)
            return {
              deliveredAt: i,
              quantity: totalQuantity
            }
          } else {
            return null
          }
        })
        return result.filter(Boolean)
      })
    },
    handlerExpectQuantity(val) {
      const dataInventory = get(this.item, 'data.inventories')
      const dataQuantity = get(val, 'quantityByDeliveredAt')
      if (dataInventory && dataQuantity) this.mapExpectQuantity(dataInventory, dataQuantity)
      this.$emit('mappingDone')
    },
    formatNumber(number) {
      return !isNaN(Number(number)) ? Number(number).toLocaleString('en-US') : '--'
    }
  },
  watch: {
    inventory: {
      handler(val) {
        if (Array.isArray(val) && val.length) {
          this.totalQuantity = []
          this.handlerHeader(val)
        } else {
          this.items = []
          this.headers = get(this.item, 'data.inventories', {})
        }
      },
      immediate: true
    },
    expectQuantity: {
      async handler(val) {
        if (val) {
          this.totalQuantity = []
          this.handlerExpectQuantity(val)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.advanced-info__wrapper {
  width: 100%;
  overflow-x: auto;
}

.table-container {
  max-width: 100%;
  overflow-x: auto;
}

.child-table {
  display: table;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;
  width: 100%;
}

tbody {
  background-color: white;
}

.child-table th,
.child-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  width: 100px;
  text-align: right;
}

.child-table th {
  height: 70px;
}

.header-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
}

.child-table td {
  height: 55px;
}

.child-table tbody tr:first-child {
  color: red;
}
</style>
